import { createContext, useContext, type ComponentProps } from "react";
import { PureAbility } from "@casl/ability";
import { createContextualCan } from "@casl/react";
import { Actions, Subjects } from "@shared/lib/casl/types";

export type AppAbility = PureAbility<[Actions, Subjects]>;

const defaultAbility = new PureAbility<[Actions, Subjects]>();
export const AbilityContext = createContext<AppAbility>(defaultAbility);

const BaseCan = createContextualCan<AppAbility>(AbilityContext.Consumer);

export const Can = (props: ComponentProps<typeof BaseCan>) => {
  return (
    <BaseCan {...props}>
      {(allowed, ability) => {
        if (typeof props.children === "function") {
          return props.children(allowed, ability);
        }
        return allowed ? props.children : null;
      }}
    </BaseCan>
  );
};

export const CanDebug = ({ I, a, children }: any) => {
  const ability = useContext(AbilityContext);
  const allowed = ability.can(I, a);

  // eslint-disable-next-line no-nested-ternary
  return typeof children === "function"
    ? children(allowed)
    : allowed
      ? children
      : null;
};
